import { COMPANY_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import useDefaultCardFooterAction from '../default/useDefaultCardFooterAction';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import I18n from 'I18n';
import PortalIdParser from 'PortalIdParser';
const useCompanyCardFooterAction = args => {
  const {
    hasScope,
    toObjectTypeId,
    total,
    usageTracker,
    fromObjectId,
    fromObjectTypeId
  } = args;

  // Always call hooks at the top level
  const defaultBehavior = useDefaultCardFooterAction(args);
  const sendOpenIframeModalMessage = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_IFRAME_MODAL);
  const portalId = PortalIdParser.get();
  const accountMapUrl = `/buying-groups/${portalId}/account-map/${fromObjectTypeId}/${fromObjectId}/embed`;

  // Only override for company-to-company associations with account-map-read-access scope and >0 total
  const shouldOverride = hasScope('account-map-read-access') && fromObjectTypeId === COMPANY_TYPE_ID && toObjectTypeId === COMPANY_TYPE_ID && total !== undefined && total !== null && total > 0;
  if (!shouldOverride) {
    // Return default behavior for the new card system
    return defaultBehavior;
  }

  // Custom action for account mapping
  const handleAccountMapClick = () => {
    usageTracker === null || usageTracker === void 0 || usageTracker.track('sidebar-interaction', {
      type: toObjectTypeId,
      action: 'view account map'
    });
    sendOpenIframeModalMessage({
      instanceId: 'account-map-iframe',
      url: accountMapUrl,
      width: 5000,
      height: 5000,
      title: I18n.text('cardAssociatedObjects.accountMapModalTitle'),
      noPadding: true
    });
  };

  // Show secondary action as a link button
  const secondaryActionConfig = {
    label: I18n.text('cardAssociatedObjects.viewAccountMap'),
    onClick: handleAccountMapClick,
    external: false
  };
  return {
    primaryActionConfig: defaultBehavior.primaryActionConfig,
    secondaryActionConfig
  };
};
export default useCompanyCardFooterAction;